<mat-card *transloco="let t">
  <mat-card-content
    fxLayout
    fxLayout.xs="column"
    fxLayoutAlign="start center"
    fxLayoutAlign.xs="start start"
  >
    <div fxLayout fxLayoutAlign="start center" style="color: #ffffff">
      <mat-icon>error</mat-icon><span>&nbsp;</span>
      <strong>{{ t('app.general.caution') }}:</strong>
      <span>&nbsp;{{ t('app.license.expired') }}</span>
    </div>

    <div fxFlex="1 1 auto"></div>

    <div fxLayout fxLayoutAlign="start center">
      <a
        mat-raised-button
        href="{{ t('app.license.url') }}"
        target="_blank"
        color="primary"
      >
        {{ t('app.license.request-abo') }}
      </a>
    </div>
  </mat-card-content>
</mat-card>
